<script>
  export let address = {}
  export const coordinates = []

</script>

<style>
  div {
    margin-bottom: 2rem;
  }
</style>

{#if address}
  <div>
    {#if address.phone_number}<p>{address.phone_number}</p>{/if}
    {#if address.email}<p>{address.email}</p>{/if}
  </div>
{/if}
